
import { Paper, Typography, Button, Modal} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { puppeteertest } from "../api/customerapi";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    modalText: {
      marginLeft: theme.spacing(30),
      marginRight: theme.spacing(4),
      width: theme.spacing(120),
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(2),
      alignItems: 'center',
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
      
  }));

const Knowledge = () => {

    const classes = useStyles();
   
    
    async function scrape(){
      const msg="Hi"
      const sentmsg=await puppeteertest(msg)
    }
      

    return (  
        <Paper variant="outlined" className={classes.paper} elevation={10}>        
           
              
                 <div align="center">
                <Button href="https://docs.google.com/document/d/1ZUOr1W3rXb8TQgWPb9y0WBLF09BWQIw95-c8XNNqbeQ/edit#" target="_blank" variant="outlined"  className={classes.button}>Sales Process</Button>
                <Button href="https://docs.google.com/document/d/15HsIUZp6ODPz6aIpq4CRK7UJ-HjZlJa9lZES3PqmMTM/edit" target="_blank" variant="outlined"  className={classes.button}>Daily Process for SP</Button>
                <Button href="https://docs.google.com/document/d/132DvstZqHeiHo6GTPNnGH5jM2k4Ci6H9FqGhtEgfE-M/edit" target="_blank" variant="outlined"  className={classes.button}>Kashmir</Button>
                <Button href="https://docs.google.com/document/d/1AJjwLhs2nwotui-cY5odkH01ztjESG8WxuBhpkTvcDc/edit" target="_blank" variant="outlined"  className={classes.button}>Bali</Button>
                <Button href="https://docs.google.com/spreadsheets/d/1gWAqen5iHPqXQDe2gfEcNE8YY9R9tuxC2YbVmDtyX7Y/edit#gid=0" target="_blank" variant="outlined"  className={classes.button}>Lead Management</Button>
                <Button href="https://docs.google.com/spreadsheets/d/10N5jTc8A3BoaLLRETYRYLrBMyYjwP5-EVHxWPlMM_XI/edit#gid=0" target="_blank" variant="outlined"  className={classes.button}>Leave Management</Button>
                <Button href="https://docs.google.com/document/d/1fmWE1Vf4oRNxWW-4UU-fIs7M0sipEoJ-YN4qVucdCQ0/edit#" target="_blank" variant="outlined"  className={classes.button}>HR Policy</Button>
                <Button href="https://docs.google.com/document/d/14QBx6dqEXhtx9-E2p9LQmnoBL_dRKHlKPUwE7YXmdNY/edit" target="_blank" variant="outlined"  className={classes.button}>Asset Policy</Button>
                <Button href="https://docs.google.com/document/d/1bOSYIYtyBr1FxUp2mr3QdBoDXMFWs2E8eDqYPZMy0PM/edit" target="_blank" variant="outlined"  className={classes.button}>Expense Policy</Button>
                <Button href="https://docs.google.com/document/d/1EyiopKFaoY0uGHq_QWTYJCIBxveweYcEdxZ8YvfksN4/edit" target="_blank" variant="outlined"  className={classes.button}>Objection Handling</Button>
                <Button href="https://docs.google.com/spreadsheets/d/1tqZtl1wCIykATTnMkTOO57hr-S6p2dUQ5Wu9fuvlmx4/edit" target="_blank" variant="outlined"  className={classes.button}>L2 Training Material</Button>
                <Button href="https://drive.google.com/drive/folders/1Dg3tjlBFHB33ySvig12ElKo7IJYkU8xu" target="_blank" variant="outlined"  className={classes.button}>Destination Vidoes</Button>
                <Button href="https://docs.google.com/spreadsheets/d/19hFwV53SKI73ALxJ6YHeUmuvJ3E60pNWC1Hzy0RZWnI/edit#gid=0" target="_blank" variant="outlined"  className={classes.button}>Honeymoon Product</Button>
                <Button href="https://docs.google.com/document/d/18-2MHxkS4x7Fk5yCy-EmWmZE8VUanlf5Reu-d-he2Hk/edit" target="_blank" variant="outlined"  className={classes.button}>PS Customer Messages</Button>
                {/* {cuser=="Debayan"?(<Button onClick={() => scrape()} variant="outlined"  className={classes.button}>Test</Button>):""} */}
            </div>           
        </Paper>
    );
}
 
export default Knowledge;